import React from 'react';

const card = 'rounded-xl border border-slate-800 bg-slate-900/70 p-4';

const ExperienceSummaryCards = ({ summary = {} }) => {
  const items = [
    { label: 'Pelanggan Risiko Tinggi', value: summary.highRiskCustomers || 0 },
    { label: 'Risiko Komplain Kritis', value: summary.criticalComplaintRisk || 0 },
    { label: 'Risiko Churn Kritis', value: summary.criticalChurnRisk || 0 },
    { label: 'Prioritas Outreach', value: summary.outreachCandidates || 0 },
    { label: 'Area Memburuk', value: summary.worseningAreas || 0 },
  ];

  return (
    <section className="grid gap-3 md:grid-cols-2 xl:grid-cols-5">
      {items.map((item) => (
        <div key={item.label} className={card}>
          <div className="text-xs uppercase tracking-[0.14em] text-slate-400">{item.label}</div>
          <div className="mt-1 text-2xl font-semibold text-slate-100">{item.value}</div>
        </div>
      ))}
    </section>
  );
};

export default ExperienceSummaryCards;
